<template>
  <div
    class="w-auto h-auto collapse navbar-collapse max-height-vh-100 h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-collapse :navText="$t(&quot;Dashboard&quot;)" :to="{ name: 'Dashboard' }">
          <template #icon>
            <shop />
          </template>
        </sidenav-collapse>
      </li>

      <li class="nav-item">
        <sidenav-collapse :navText="$t(&quot;Account Information&quot;)" :to="{ name: 'Profile' }">
          <template #icon>
            <switches />
          </template>
        </sidenav-collapse>
      </li>

      <li class="nav-item">
        <sidenav-collapse :navText="$t(&quot;Banking Information&quot;)" :to="{ name: 'Payment Dtails' }">
          <template #icon>
            <credit-card />
          </template>
        </sidenav-collapse>
      </li>

      <li class="nav-item">
        <sidenav-collapse :navText="$t(&quot;Payroll &amp; Rates&quot;)" :to="{ name: 'Payroll Rates' }">
          <template #icon>
            <office />
          </template>
        </sidenav-collapse>
      </li>

      <li class="nav-item">
        <sidenav-collapse :navText="$t(&quot;Enrollment&quot;)" :to="{ name: 'Enrollment' }">
          <template #icon>
            <credit-card />
          </template>
        </sidenav-collapse>
      </li>

      <li class="nav-item">
        <sidenav-collapse :navText="$t(&quot;Files&quot;)" :to="{ name: 'Vendor Forms' }">
          <template #icon>
            <credit-card />
          </template>
        </sidenav-collapse>
      </li>

      <li class="nav-item"><sidenav-collapse :navText="$t('Signature')" :to="{ name: 'Signature' }"><template #icon><credit-card /></template></sidenav-collapse></li>
      <li class="nav-item">
        <sidenav-collapse :navText="$t(&quot;Invoice Sheets&quot;)" :to="{ name: 'Invoice' }">
          <template #icon>
            <office />
          </template>
        </sidenav-collapse>
      </li>

      <li class="nav-item">
        <sidenav-collapse :navText="$t(&quot;Message Center&quot;)" :to="{ name: 'Message' }">
          <template #icon>
            <credit-card />
          </template>
        </sidenav-collapse>
      </li>

      <li class="nav-item">
        <details class="portal-account-menu" :open="$route.path === '/account-settings' || $route.path === '/change_password' || $route.path === '/device-management'">
          <summary class="nav-link" data-worker-guide="account"><i class="fas fa-user-cog me-2" aria-hidden="true"></i><portal-text message="Account Management" /><span class="ms-auto" aria-hidden="true">▾</span></summary>
          <ul class="navbar-nav ms-3">
            <li class="nav-item"><sidenav-collapse :navText="$t('Change Password')" :to="{ name: 'Change Password' }"><template #icon><credit-card /></template></sidenav-collapse></li>
            <li class="nav-item"><sidenav-collapse navText="Device Management" :to="{ name: 'Device Management' }"><template #icon><i class="fas fa-desktop" aria-hidden="true"></i></template></sidenav-collapse></li>
            <li class="nav-item"><sidenav-collapse :navText="$t('Settings')" :to="{ name: 'Settings' }"><template #icon><credit-card /></template></sidenav-collapse></li>
          </ul>
        </details>
      </li>
      <li class="nav-item"><button type="button" class="nav-link w-100 border-0 text-start" data-worker-guide="guide" @click="openGuide"><span class="icon icon-shape icon-sm bg-white shadow border-radius-md me-2"><i class="fas fa-question-circle" aria-hidden="true"></i></span><portal-text message="Guide" /></button></li>
    </ul>
  </div>
</template>

<script>
import SidenavCollapse from "./SidenavCollapse.vue";

import Shop from "../../components/Icon/Shop.vue";
import Office from "../../components/Icon/Office.vue";
import Switches from "../../components/Icon/Switches.vue";
import CreditCard from "../../components/Icon/CreditCard.vue";

export default {
  name: "SidenavList",
  props: {
    cardBg: String,
  },
  data() {
    return {
      title: "Soft UI Dashboard PRO",
      controls: "dashboardsExamples",
      isActive: "active",
    };
  },
  components: {
    SidenavCollapse,
    Shop,
    Office,
    Switches,
    CreditCard,
  },
  methods: {
    openGuide() { window.dispatchEvent(new CustomEvent('bfms-guide-open')); },
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
  },
};
</script>
